import React from 'react';

const NotFound = () => {
    return (
        <div
            style={{
                marginTop: '20px',
                textAlign: 'center',
                fontSize: '36px',
                lineHeight: '40px',
                fontWeight: '500',
            }}
        >
            404 Not Found
        </div>
    );
};

export default NotFound;
